import { create } from "zustand";

import type { ScheduleAppointment } from "@/features/consultations/models";
import { CONSULTATION_PURPOSE } from "@/shared/models/legacy-constants";
import type { ConsultationPurpose } from "@/shared/models/legacy-types";

interface ConsultationStoreState {
  purpose: ConsultationPurpose;
  appointmentType?: ScheduleAppointment["type"];
  setPurpose: (purpose: ConsultationPurpose) => void;
  setAppointmentType: (appointmentType: ScheduleAppointment["type"]) => void;
}

export const useConsultationStore = create<ConsultationStoreState>()((set) => ({
  purpose: CONSULTATION_PURPOSE.REFILL,

  setPurpose: (purpose: ConsultationPurpose) => {
    set(() => ({ purpose }));
  },
  setAppointmentType: (appointmentType: ScheduleAppointment["type"]) => {
    set(() => ({ appointmentType }));
  },
}));
